import { ApiErrorData, ApiResponse } from 'models/ApiResponse';
import { KitCompany } from 'models/KitCompany';

import { FunctionsHelper } from 'utils/FunctionsHelper';
import MainBackendAxios from 'utils/MainBackendAxios';

export const KitCompanyService = {
  getByCountry: async (
    countryCode: string
  ): Promise<ApiResponse<KitCompany[] | ApiErrorData>> => {
    try {
      const response = await MainBackendAxios.get(
        `/kit-company/get-by-country/${countryCode}`
      );

      return {
        success: true,
        status: response.status,
        data: response?.data?.data as KitCompany[],
      };
    } catch (err: any) {
      return FunctionsHelper.getErrorFormat(err);
    }
  },
};
